import React, {useContext, useEffect, useState} from 'react';
import {Button, message} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import EditComponent from '../common/EditComponent';
import ImportTableModal from '../common/ImportTableModal';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod, PostToJava} from '../common/ApiMethod';
import SearchBox from '../common/SearchBoxComponent';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';
import {SortByMbskPost} from '../common/SortListByPost';
import BatchDelTableComponent from '../common/BatchDelComponent';

export default function EmployeeInformation(props) {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/society/api!employeeInformation.do';
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const onSelectChange = (newSelectedRowKeys) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
	};

	const hasSelected = selectedRowKeys.length > 0;

	const resetSelect = () => {
		setSelectedRowKeys([]);
	};

	const deleteSelected = () => {
		setLoading(true);
		const ids = selectedRowKeys.map(key => dataSource[key - 1].peopleId);
		const batchDelApi = Arguments.host + '/society_organization/batchDelete/api!delWorkPeople.do';
		const postData = {
			delIds: ids.join('&&'),
		};
		PostToJava(batchDelApi, postData).then(res => {
			if (res?.data.code === 1) {
				message.success('批量删除成功');
			} else {
				message.error('删除失败');
			}
			setLoading(false);
			setSelectedRowKeys([]);
		}).then(() => GetApiMethod({getApi, setDataSource, setCopyDataSource}));
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'key',
			width: 100,
			sorter: (a, b) => a.key - b.key,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '姓名',
			dataIndex: 'peopleName',
			width: 100,
			sorter: (a, b) => a.peopleName.localeCompare(b.peopleName),
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '性别',
			responsive: ['lg'],
			dataIndex: 'peopleSex',
			width: 80,
		},
		{
			title: '出生日期',
			dataIndex: 'peopleBorn',
			width: 120,
		},
		{
			title: '政治面貌',
			dataIndex: 'peopleZzmm',
			width: 120,
		},
		{
			title: '学历',
			dataIndex: 'peopleEducation',
		},
		{
			title: '社团职务',
			dataIndex: 'mbskPost',
			width: 140,
		},
		{
			title: '工作单位（或原单位）',
			responsive: ['lg'],
			dataIndex: 'peopleUnit',
			width: 180,
		},
		{
			title: '职务',
			responsive: ['lg'],
			dataIndex: 'peoplePost',
		},
		{
			title: '职称',
			responsive: ['lg'],
			dataIndex: 'peopleProfessional',
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/society/api!addEmployeeInformation.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const newData = dataSource.map(
		(
			{
				peopleName,
				peopleSex,
				peopleBorn,
				peopleZzmm,
				peopleEducation,
				mbskPost,
				peopleUnit,
				peoplePost,
				peopleProfessional,
			},
		) => (
			{
				'姓名': peopleName,
				'性别': peopleSex,
				'出生日期': peopleBorn,
				'政治面貌': peopleZzmm,
				'学历': peopleEducation,
				'社团职务': mbskPost,
				'工作单位（或原单位）': peopleUnit,
				'职务': peoplePost,
				'职称': peopleProfessional,
			}
		),
	);

	const indexDataSource = SortByMbskPost(dataSource).map((data, index) => ({key: index + 1, ...data}));

	const tableTitle = [
		'people_name',
		'people_sex',
		'people_born',
		'people_zzmm',
		'people_education',
		'mbsk_post',
		'people_unit',
		'people_post',
		'people_professional',
	];

	return (
		<>
			<Button type="primary" onClick={() => props.history.push('/society/employee-information/add')}
					style={{marginBottom: 10}}>新增</Button>
			<ImportTableModal
				titleText="从业人员信息导入"
				templateUrl={Arguments.reactUrl.replace('/#', '') + '/att/words/民非从业人员信息导入模板.xlsx'}
				uploadUrl={Arguments.host + '/society_organization/batchImport/api!workPeople.do'}
				incrementId={'mbsk_work_people_info.people_id'}
				getApi={getApi}
				tableTitle={tableTitle}
				duplicateApi={Arguments.host + '/society_organization/society/api!duplicateEmployeeInformation.do'}
			/>
			<ExportToExcel tableData={newData}/>
			<SearchBox placeholder="输入姓名/单位/政治面貌关键字"/>
			<Button type="primary" onClick={() => resetSelect()} disabled={!hasSelected} style={{marginLeft: 20}}>
				取消选择
			</Button>
			<Button type="primary" danger onClick={() => deleteSelected()} disabled={!hasSelected} loading={loading}
					style={{marginLeft: 10}}>
				全部删除
			</Button>
			<BatchDelTableComponent
				rowSelection={rowSelection}
				dataSource={indexDataSource}
				columns={columns}
				rowKey={(item) => item.key}
			/>
		</>
	);
}

